import { ReactElement } from 'react';
import { TextField } from '@ff-it/form';
import { DepartmentField } from 'modules/supplier/department/DepartmentField';

export function Form(): ReactElement {
  return (
    <div className="container px-0 ml-0">
      <div className="form-row">
        <TextField name="name" label="Name" className="col-md-6" required />
      </div>
      <div className="form-row">
        <DepartmentField name="channels" label="Departments" className="col-md-6" required isMulti />
      </div>
    </div>
  );
}
